import { render, staticRenderFns } from "./MerchantCategoryList.vue?vue&type=template&id=eff2cc12&"
import script from "./MerchantCategoryList.vue?vue&type=script&lang=ts&"
export * from "./MerchantCategoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports